
import { useLocation, useNavigate } from 'react-router-dom';
import { User, BarChart3, MessageCircle, ClipboardList } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCurrentUserModule } from '@/hooks/useUserModule';

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: currentModule } = useCurrentUserModule();

  // Determine the third nav item based on current module
  const getModuleNavItem = () => {
    if (!currentModule) {
      // Default to coaching if no current module
      return {
        id: 'coaching',
        label: 'Coaching',
        icon: MessageCircle,
        path: '/module'
      };
    }

    const { screenType } = currentModule.module;

    switch (screenType) {
      case 'survey':
      case 'survey_intro':
        return {
          id: 'survey',
          label: 'Survey',
          icon: ClipboardList,
          path: '/module'
        };
      
      case 'chat':
      case 'coaching':
        return {
          id: 'coaching',
          label: 'Coaching',
          icon: MessageCircle,
          path: '/module'
        };
        
      case 'profile':
        return {
          id: 'module',
          label: 'Continue',
          icon: User,
          path: '/module'
        };
        
      default:
        return {
          id: 'coaching',
          label: 'Coaching',
          icon: MessageCircle,
          path: '/module'
        };
    }
  };

  const moduleNavItem = getModuleNavItem();

  const navItems = [
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile/view'
    },
    {
      id: 'updates',
      label: 'Updates',
      icon: BarChart3,
      path: '/updates'
    },
    moduleNavItem
  ];

  const isActive = (path: string, id: string) => {
    if (id === 'coaching') {
      return location.pathname.startsWith('/coaching');
    }
    if (id === 'profile') {
      return location.pathname.startsWith('/profile');
    }
    if (id === 'survey') {
      return location.pathname.startsWith('/survey');
    }
    if (id === 'module') {
      // For the generic "Continue" button, check if we're on the module's target page
      return location.pathname === path;
    }
    return location.pathname === path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 lg:hidden">
      <div className="flex justify-around items-center px-4 py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path, item.id);
          
          return (
            <Button
              key={item.id}
              variant="ghost"
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center gap-1 h-auto py-2 px-3 ${
                active 
                  ? 'text-black bg-gray-100' 
                  : 'text-gray-500 hover:text-black hover:bg-gray-50'
              }`}
            >
              <Icon className="h-5 w-5" />
              <span className="text-xs font-medium">{item.label}</span>
            </Button>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;
